interface ChannelDetailProps {
  index: number;
  slug: string;
  icon: string;
  name: string;
  summary: string;
  scenes: string[];
  requirements: string[];
  tag: string;
}

export default function ChannelDetail({
  index,
  slug,
  icon,
  name,
  summary,
  scenes,
  requirements,
  tag,
}: ChannelDetailProps) {
  const number = String(index + 1).padStart(2, "0");

  return (
    <article
      id={slug}
      className="scroll-mt-28 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 py-12 md:py-16 border-t border-background-200 first:border-t-0"
    >
      <div className="lg:col-span-4">
        <div className="flex items-center gap-4">
          <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-2xl">
            <i className={icon}></i>
          </span>
          <span className="font-heading text-3xl font-bold text-background-400">{number}</span>
        </div>
        <h2 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          {name}
        </h2>
        <span className="mt-3 inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs">
          {tag}
        </span>
        <p className="mt-5 text-[15px] leading-relaxed text-foreground-600">{summary}</p>
      </div>

      <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="p-6 rounded-lg bg-background-100 border border-background-200">
          <h3 className="m-0 flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
            <i className="ri-focus-3-line text-primary-600"></i>
            适用场景
          </h3>
          <ul className="mt-4 space-y-3">
            {scenes.map((scene) => (
              <li key={scene} className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-primary-400 mt-2 shrink-0"></i>
                <span className="leading-relaxed">{scene}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="p-6 rounded-lg bg-background-100 border border-background-200">
          <h3 className="m-0 flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
            <i className="ri-error-warning-line text-accent-600"></i>
            提交前请注意
          </h3>
          <ul className="mt-4 space-y-3">
            {requirements.map((req) => (
              <li key={req} className="flex items-start gap-2.5 text-sm text-foreground-700">
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500 mt-2 shrink-0"></i>
                <span className="leading-relaxed">{req}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </article>
  );
}